import superagent from 'superagent';
// import router from '../routes';
// router.push(`/${context.rootState.language}/promoter/dashboard`);

const request = {
  make(options, cb) {
    const type = options.type;
    const url = options.url;
    let data = {};
    if (typeof window.vue !== 'undefined') {
      window.vue.$store.dispatch('setWaitingForServer', true);
    }
    if (typeof options.data !== 'undefined') {
      data = options.data;
    }
    const req = superagent();
    req.method = type.toUpperCase();
    req.url = url;
    req.set('Content-Type', 'application/json');

    const jwt = localStorage.getItem('jwt');
    if (jwt !== null) {
      req.set('Authorization', `Bearer ${jwt}`);
    }

    if (type.toUpperCase() === 'GET') {
      req.query(data);
    } else {
      req.send(data);
    }
    req.end((err, res) => {
      if (typeof window.vue !== 'undefined') {
        window.vue.$store.dispatch('setWaitingForServer', false);
      }
      if (res) {
        if (err) {
          if (res.status === 401) {
            if (typeof window.vue.$route !== 'undefined') {
              const fullPath = window.vue.$route.fullPath.split(/\/|\?/);
              if (fullPath.indexOf('login') === -1) {
                const message = 'You Session Has Timedout.';
                const debugMessage = '';
                const timeout = 7000;
                window.vue.$store.dispatch('setGlobalMessage', {
                  message,
                  debugMessage,
                  className: 'warning',
                  timeout,
                });
                setTimeout(() => {
                  window.vue.$store.commit('clearState');
                }, 2000);
              }
            }
          } else if (res.status === 500) {
            const message = `An unexpected error has occured. This should never happen.
            Please contact us at info@booknatura.com if you need any help.`;
            const debugMessage = '';
            const timeout = 7000;
            window.vue.$store.dispatch('setGlobalMessage', {
              message,
              debugMessage,
              className: 'danger',
              timeout,
            });
          } else if (res.status === 503) {
            window.location.reload(1);
          }
        }
        cb(err, res);
      }
    });
  },
};


export default request;



// WEBPACK FOOTER //
// ./src/request.js